var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4",attrs:{"outlined":"","ripple":false,"loading":_vm.loading}},[_c('v-card-title',[_vm._v("Produits"),_c('v-spacer')],1),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headersProduit,"items":_vm.cmdRows,"disable-pagination":"","hide-default-footer":"","mobile-breakpoint":0},scopedSlots:_vm._u([{key:"item.finValidite",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.forfait.fftId > 0?item.finValidite:''))]}},{key:"item.crwTarif",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("currency")(item.crwTarif)))]}},{key:"item.prixTotal",fn:function(ref){
var item = ref.item;
return [_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.prixTotal)))])]}},{key:"item.crwTva",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("tva")(item.crwTva)))]}},{key:"item.tva",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("currency")(item.tva)))]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }